var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"card"}},[_c('v-card',{attrs:{"elevation":"6"}},[_c('v-card-title',[_vm._v(" Voting Description "),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closePrompt}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_c('v-card-text',[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.recordData.VotingDescription)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }